module.exports = __webpack_public_path__ + "static/consulting_outline-d5743c3fd5a4a15993a38951e095e9c7.png";